/**
 * Capitalizes the first letter of a string
 * @param str - The input string to capitalize
 * @returns The string with the first letter capitalized
 */
export const capitalize = (str: string): string => {
  if (!str || typeof str !== 'string') {
    return str;
  }

  return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 * Capitalizes the first letter of each word in a string
 * @param str - The input string to capitalize each word
 * @returns The string with each word's first letter capitalized
 */
export const capitalizeWords = (str: string): string => {
  if (!str || typeof str !== 'string') {
    return str;
  }

  return str
    .split(' ')
    .map((word) => capitalize(word))
    .join(' ');
};

/**
 * Converts a string to title case (capitalizes first letter, lowercases the rest)
 * @param str - The input string to convert to title case
 * @returns The string in title case
 */
export const toTitleCase = (str: string): string => {
  if (!str || typeof str !== 'string') {
    return str;
  }

  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
